import React from 'react';

/* eslint-disable react/prop-types */
const createOption = (props) => {
  return (
    // The bootstrap bg-color danger class isn't dark enough.
    // Tried to make this an alert but the styling was not working out
    // Hard code the color to match the danger button.
    <span style={{ 'background-color': '#d9534f' }}>
      Create Option <strong>&quot;{props.searchTerm}&quot;</strong>
    </span>
  );
};
/* eslint-enable react/prop-types */

export default createOption;
